import Cookies from "js-cookie";

export async function apiClient<T>(
  endpoint: string,
  options: RequestInit = {},
): Promise<T> {
  const cookieToken = Cookies.get("auth_token");
  const activeToken = cookieToken;

  const url = `${endpoint}`;
  const response = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${activeToken}`,
      ...options.headers,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.error || errorData.message || `HTTP error! status: ${response.status}`,
    );
  }

  const contentType =
    response.headers.get("Content-Type") ||
    response.headers.get("content-type");
  if (contentType && !contentType.includes("application/json")) {
    return response.blob() as unknown as T;
  }

  return response.json();
}
